import { Component, OnInit, Input, SimpleChanges } from "@angular/core";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
import { ProgramasService } from '../../services/programas.service';

@Component({
	selector: "app-documentos-selector",
	templateUrl: "./documentos-selector.component.html",
	styleUrls: ["./documentos-selector.component.css"],
})
export class DocumentosSelectorComponent implements OnInit {
	@Input() Documentos: FormGroup;
	@Input() documentosEnProgramas: any = [];
	@Input() visibleColumnaRequerido: boolean = false;
	listadoTipoDocumentos: any = [];
	documentosSeleccionadosCampo: any = [];
	documentosSeleccionadosTabla: any = [];

	constructor(
		private servicioProgramas: ProgramasService,
		private formBuilder: FormBuilder
	) {}

	ngOnInit(): void {
		this.obtenerTiposDocumentos();
	}

	ngOnChanges(changes: SimpleChanges) {
		this.obtenerTiposDocumentos();
	}

	get tiposDocumentos() {
		return this.Documentos.get("ListadoDocumentos") as FormArray;
	}

	ListadoDocumentos(id, requiere, esRequerido) {
		return this.formBuilder.group({
			DocumentoID: [id, ""],
			Requiere: [requiere, ""],
			EsRequerido: [esRequerido, ""],
		});
	}

	obtenerTiposDocumentos() {
		this.servicioProgramas.listarTiposDocumentos().subscribe((data) => {
			this.listadoTipoDocumentos = data;

			this.cargarDocumentoEnProgramaTabla();
			this.crearDocumentos();
		});
	}

	crearDocumentos() {
		this.tiposDocumentos.controls = [];
		if (this.documentosEnProgramas.length > 0) {
			this.documentosSeleccionadosTabla.forEach((documento, index) => {
				let docPrograma = this.documentosEnProgramas.find(
					(doc) => doc.Documento_ID === documento.ID
				);


				if (docPrograma) {
					documento['EsRequerido'] = docPrograma.Requerido ? docPrograma.Requerido: documento.Requerido

					if (docPrograma && docPrograma.Requerido_Renov) {
						documento["requiere"] = "2";
					} else if (docPrograma) {
						documento["requiere"] = "1";
					}
				} else {
					documento["requiere"] = "1";
					documento['EsRequerido'] = docPrograma ? docPrograma.Requerido: documento.Requerido

				}

				this.tiposDocumentos.push(
					this.ListadoDocumentos(
						documento.ID,
						documento.requiere ? documento.requiere : "0",
						documento.EsRequerido
					)
				);
			});
		} else {
			this.documentosSeleccionadosTabla.forEach((documento) => {
				this.tiposDocumentos.push(
					this.ListadoDocumentos(
						documento.ID,
						documento.requiere ? documento.requiere : "1",
						documento.EsRequerido
					)
				);
			});
		}
	}

	obtenerDocumentos(e) {
		this.documentosSeleccionadosCampo = e;
		this.agregarDocumentosTabla();
	}

	agregarDocumentosTabla() {
		this.documentosSeleccionadosTabla = [];

		this.listadoTipoDocumentos.forEach((documento) => {
			let documentoEncontrado = this.documentosSeleccionadosCampo.find(
				(doc) => doc == documento.ID
			);

			if (documentoEncontrado) {
				this.documentosSeleccionadosTabla.push(documento);
			}
		});

		this.crearDocumentos();
	}

	cargarDocumentoEnProgramaTabla() {
		this.documentosSeleccionadosTabla = [];
		this.documentosSeleccionadosCampo = [];

		this.listadoTipoDocumentos.forEach((documento) => {
			let documentoEncontrado = this.documentosEnProgramas.find(
				(doc) => doc.Documento_ID === documento.ID
			);

			if (documentoEncontrado) {
				this.documentosSeleccionadosTabla.push(documento);
				this.documentosSeleccionadosCampo.push(documento.ID);
			}
		});

		this.Documentos.get("documentosSeleccionados").setValue(
			this.documentosSeleccionadosCampo
		);
	}

	limpiarCamposTable() {
		this.documentosSeleccionadosCampo = [];
		this.documentosSeleccionadosTabla = [];
		this.crearDocumentos();
		this.Documentos.get("documentosSeleccionados").setValue([]);
	}

	agregarRequeridoDocumento(documento) {
		this.documentosSeleccionadosTabla.find((doc) => {
			if (doc.ID === documento.ID) {
				doc.EsRequerido = !doc.EsRequerido;
			}
		});
	}

	requeridosTodos() {
		if (this.documentosSeleccionadosTabla.length > 0) {
			this.documentosSeleccionadosTabla.forEach((doc) => {
				doc.EsRequerido = !doc.EsRequerido;
			});

			this.crearDocumentos();
		}
	}
}
